import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';

import { GIButton, Modal } from 'app-components';

import { ModalContextType } from '@contexts/modalContext';
import { configs } from '@constants/configs/configs';

import { StyledModalButtonFooter } from '../voterRegistration.styled';
import useVoterRegistration from '../useVoterRegistration';

interface IModalProps extends ModalContextType {}

const VoterRegistrationCancelModal = ({ closeAllModals }: IModalProps) => {
    const { updateVoterRegistrationFlag } = useVoterRegistration();
    const { state } = useLocation();
    const navigate = useNavigate();
    const { ssapApplicationId } = state || {};

    const onContinue = async () => {
        const success = await updateVoterRegistrationFlag(ssapApplicationId, true);
        if (success) {
            closeAllModals();
            navigate(configs.routes.INDPORTAL);
            return;
        }

        closeAllModals();
    };

    return (
        <Modal id="voter_registration_success_modal">
            <Modal.Header
                id="modal_header"
                titleId={'voterRegistration.form.modal.cancel.header'}
                onHide={closeAllModals}
            />
            <Modal.Body>
                <p>
                    <FormattedMessage id="voterRegistration.form.modal.cancel.body" />
                </p>
            </Modal.Body>
            <Modal.Controls>
                <StyledModalButtonFooter>
                    <GIButton
                        id="goBack_btn"
                        labelId="button.go_back"
                        variant="secondary"
                        onClickHandler={closeAllModals}
                    />
                    <GIButton id="Continue_btn" labelId="button.continue" onClickHandler={onContinue} />
                </StyledModalButtonFooter>
            </Modal.Controls>
        </Modal>
    );
};

export default VoterRegistrationCancelModal;
